import React from 'react';
import { useFormikContext, setIn, getIn } from 'formik';

function isUpdater<T>(
  value: React.SetStateAction<T>
): value is (prevState: T) => T {
  return typeof value === 'function';
}

export const useSetFieldValueWithoutDirty = <T>(name: string) => {
  const formik = useFormikContext();
  // Use a ref to always get the latest formik state at execution time
  const formikRef = React.useRef(formik);
  formikRef.current = formik;

  return React.useCallback(
    (newValue: React.SetStateAction<T>) => {
      const { resetForm, values, touched, errors } = formikRef.current;
      const current = getIn(values, name) as T;
      const resolvedValue = isUpdater(newValue) ? newValue(current) : newValue;

      resetForm({
        values: setIn(values, name, resolvedValue),
        touched,
        errors,
      });
    },
    [name]
  );
};
